export default __webpack_public_path__ + "static/media/greenbelt-logo.b14cc691.png";